import type { MotionProps } from 'framer-motion';
import type { SearchBarFilterConfig } from '@fabric-app/business/search/searchbar.types';
import { SearchBarFilterType } from '@fabric-app/business/search/searchbar.types';
import { IconResourceKind, IconTag } from '@fabric-app/icons/mobile';
import { IconFolder } from '@fabric-app/icons/svg';

export const boundaryRegex = /((?!\S)\s?|^)/;

export const searchBarFilterConfigs: { [key in SearchBarFilterType]: SearchBarFilterConfig } = {
  [SearchBarFilterType.TAG]: {
    name: 'Tag',
    commandRegex: /tag:$/,
    Icon: IconTag,
  },
  [SearchBarFilterType.LOCATION]: {
    name: 'Location',
    commandRegex: /location:$/,
    Icon: IconFolder,
  },
  [SearchBarFilterType.CONTENT_TYPE]: {
    name: 'Kind',
    commandRegex: /content_type:$/,
    Icon: IconResourceKind,
  },
};

export const searchBarMotionLayoutIds = {
  group: 'search-bar',
  bg: 'search-bar-bg',
  icon: 'search-bar-icon',
  input: 'search-bar-input',
  placeholder: 'search-bar-placeholder',
};

const transition = {
  delay: 0,
  duration: 0.2,
  type: 'linear',
};

const searchButtonMotionProps: MotionProps = {
  transition: {
    delay: 0.25,
    duration: 0.15,
    type: 'linear',
  },
};

export const searchBarMotionLayoutIdProps: Record<string, MotionProps> = {
  bg: {
    layoutId: searchBarMotionLayoutIds.bg,
    transition,
  },
  icon: {
    layoutId: searchBarMotionLayoutIds.icon,
    layout: 'position' as const,
    transition,
  },
  input: {
    layoutId: searchBarMotionLayoutIds.input,
    layout: 'position' as const,
    transition,
  },
  placeholder: {
    layoutId: searchBarMotionLayoutIds.placeholder,
    layout: 'position' as const,
    transition,
  },

  addFilterButton: {
    layoutId: 'filter-add-button',
    ...searchButtonMotionProps,
  },
  addImageButton: {
    layoutId: 'filter-add-image-button',
    ...searchButtonMotionProps,
  },
  selectColorButton: {
    layoutId: 'filter-select-color-button',
    ...searchButtonMotionProps,
  },
  clearButton: {
    layoutId: 'filter-clear-button',
    ...searchButtonMotionProps,
  },
};
